import { Route, Switch } from 'react-router';

import { NotFoundPanel } from '@dreryk/react-components';

import { GroupSessionsPanel } from './GroupSessionsPanel';

const GROUP_SESSIONS_PATH = '/terapie-grupowe';

export const getGroupSessionsPath = (): string => GROUP_SESSIONS_PATH;

export const GroupSessionsRouter = (): JSX.Element => {
   return (
      <Switch>
         <Route exact path={GROUP_SESSIONS_PATH}>
            <GroupSessionsPanel />
         </Route>
         <Route>
            <NotFoundPanel />
         </Route>
      </Switch>
   );
};
